<template>
  <div id="func-1">
    <FuncionalidadeHeader :titulo="funcionalidade.parametros.dashboard.nome"/>
    <div class="msg-diretas-linhas">
      <el-button class="msg-diretas" :style="estiloBotao" round @click="filtraMensagensDiretas(notificacoes)">Mensagens diretas</el-button>
    </div>
    <div v-if="notificacoes.length" class="listagem-status">
      <template :gutter="24" v-for="(row, key) in notificacoes">
        <el-row :style="estiloLinha (row, key)" :key="key">
          <template v-for="(column, index) in columns">
            <el-col :key="index" v-bind="layoutColumn(column)">
              <el-link style=""
                       v-if="column.field === 'id_funcionalidade' && row[column.field] !== null"
                       :underline="false"
                       @click="redirecFuncionalidade(row)"
              > {{ column.label }}
              </el-link>
              <component
                :is="column.component"
                v-if="column.component"
                :column="column"
                :row="row"
                :frameId="frameId"
              />
            </el-col>
          </template>
        </el-row>
      </template>
      <el-row :cell-style="estiloLinha" style="width: 100%; text-align: center">
        <el-button v-if="showButton" class="load-notificacoes" round  :style="estiloBotaoCarregar"  @click="getNotifications">
          <span>
          <svg-icone class="active" :icone="funcionalidade.parametros.dashboard.icone" :cor="estilo.aplicacao.corPrimariaAplicacao"/>
            <span class="">
          CARREGAR MAIS NOTIFICAÇÕES
            </span>
          </span>
        </el-button>

      </el-row>
    </div>
    <div v-if="semNotificacoes" class="inbox-vazia">
      <el-image :src="emptyNotification"/>
      <h1 class="titulo-erro">{{ funcionalidade.parametros.tituloErro }}</h1>
      <h2 class="texto-erro">{{ funcionalidade.parametros.textoErro }}</h2>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { EnumStatusInbox } from '@/constants/EnumStatusInbox'
import { emptyNotificationIcone } from '@/utils/ImageBucket'
import { emitInboxClear } from '@/utils/comandosSdk'
import ColumnInbox from '@/components/column/ColumnInbox'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'

export default {
  name: 'Func1Inbox',
  components: {
    FuncionalidadeHeader
  },
  data () {
    return {
      notificacoes: [],
      syncInboxStateTimeout: null,
      columns: [
        { field: ['texto', 'data_hora_enviada', 'statusInbox'], component: ColumnInbox },
        {
          field: 'id_funcionalidade',
          fixed: true,
          label: 'Acessar Link',
          width: '100px'
        }
      ],
      msgDiretas: false,
      semNotificacoes: false,
      showButton: true
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'frameId']),
    ...mapGetters('SetupApp', ['estilo', 'aplicacao']),
    ...mapGetters('Login', ['token', 'user']),
    emptyNotification () {
      return emptyNotificationIcone()
    },
    estiloBotao () {
      if (this.msgDiretas) {
        return {
          'color': `${this.estilo.aplicacao.corFundoAplicacao}`,
          'background': `${this.estilo.aplicacao.corPrimariaAplicacao}`
        }
      } else {
        return {
          'color': `${this.estilo.aplicacao.corPrimariaAplicacao}`,
          'background': `${this.estilo.aplicacao.corFundoAplicacao}`,
          'border': `1px solid ${this.estilo.aplicacao.corPrimariaAplicacao}`
        }
      }
    },
    estiloBotaoCarregar () {
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao}`,
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}1d`,
        'border': `0px solid ${this.estilo.aplicacao.corPrimariaAplicacao}1d`
      }
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    if (this.syncInboxStateTimeout) {
      clearTimeout(this.syncInboxStateTimeout)
      this.syncInboxStateTimeout = null
    }
  },
  methods: {
    async init () {
      await this.getNotifications()
      if (this.syncInboxStateTimeout) {
        clearTimeout(this.syncInboxStateTimeout)
      }

      this.syncInboxStateTimeout = setTimeout(async () => {
        this.syncInboxStateTimeout = null
        await this.syncInboxStateOnOpen()
      }, 600)
    },
    isInboxOpen () {
      const paths = String.prototype.split
        .call(this.$route.path || '', ['/'])
        .filter((path) => path !== '')

      const idFuncionalidade = paths[0] === 'playground' ? paths[1] : paths[0]

      if (String(idFuncionalidade) !== '1' || document.visibilityState !== 'visible') {
        return false
      }

      const rootElement = this.$el
      const frameElement = window.frameElement

      if (!rootElement) {
        return false
      }

      const rootRect = rootElement.getBoundingClientRect()

      if (rootRect.width < 320 || rootRect.height < 240) {
        return false
      }

      if (!frameElement) {
        return true
      }

      const frameStyle = window.getComputedStyle(frameElement)
      const frameRect = frameElement.getBoundingClientRect()

      return frameStyle.display !== 'none' &&
        frameStyle.visibility !== 'hidden' &&
        frameRect.width >= 320 &&
        frameRect.height >= 240
    },
    async syncInboxStateOnOpen () {
      if (!this.isInboxOpen()) {
        return
      }

      const unreadMessageIds = await this.getUnreadMessageIds()
      const updated = await this.updateStatusLido(unreadMessageIds)

      if (!updated) {
        return
      }

      this.markNotificationsAsRead()
      emitInboxClear(this.frameId)
    },
    async getNotifications () {
      const notificacoesAtuais = this.notificacoes.length
      const result = await this.apiFuncionalidade.lista({
        headers: {
          bundle: this.aplicacao.bundle
        },
        query: {
          bundle: this.aplicacao.bundle,
          chaveUnica: this.user.chaveUnica,
          inicio: notificacoesAtuais,
          qtd: 10
        },
        handlerErrorIgnore: [404],
        loading: true
      })

      if (result) {
        if (result.data.length > 0) {
          result.data.forEach(d => {
            this.notificacoes.push(d)
          })
        } else {
          this.showButton = false
        }
      }

      if (!this.notificacoes.length) {
        this.semNotificacoes = true
      }
    },
    async getUnreadMessageIds () {
      const unreadMessageIds = this.notificacoes
        .filter((notificacao) => notificacao.statusInbox === EnumStatusInbox.NAO_LIDO)
        .map((notificacao) => notificacao.id_msg_envio)

      const qtd = 100

      const result = await this.apiFuncionalidade.lista({
        headers: {
          bundle: this.aplicacao.bundle
        },
        query: {
          bundle: this.aplicacao.bundle,
          chaveUnica: this.user.chaveUnica,
          qtd
        },
        handlerErrorIgnore: [404]
      })

      const notificacoes = Array.isArray(result && result.data) ? result.data : []

      if (!notificacoes.length) {
        return [...new Set(unreadMessageIds)]
      }

      notificacoes.forEach((notificacao) => {
        if (notificacao.statusInbox === EnumStatusInbox.NAO_LIDO) {
          unreadMessageIds.push(notificacao.id_msg_envio)
        }
      })

      return [...new Set(unreadMessageIds)]
    },
    async updateStatusLido (msgIDArray) {
      if (!msgIDArray.length) {
        return true
      }

      const result = await this.apiFuncionalidade.pushLido({
        payload: {
          bundle: this.aplicacao.bundle,
          chaveUnica: this.user.chaveUnica,
          statusInbox: EnumStatusInbox.LIDO,
          msgIDArray
        }
      })

      return result && result.status !== false
    },
    markNotificationsAsRead () {
      this.notificacoes.forEach((notificacao) => {
        if (notificacao.statusInbox === EnumStatusInbox.NAO_LIDO) {
          notificacao.statusInbox = EnumStatusInbox.LIDO
        }
      })
    },
    async updateStatusClicado (row) {
      await this.apiFuncionalidade.pushClicado({
        payload: {
          bundle: this.aplicacao.bundle,
          chaveUnica: this.user.chaveUnica,
          statusInbox: EnumStatusInbox.CLICADO,
          msgIDArray: [row.id_msg_envio]
        }
      })
    },
    async filtraMensagensDiretas (notificacoes) {
      this.msgDiretas = !this.msgDiretas
      if (this.msgDiretas) {
        const msgDiretas = []
        notificacoes.forEach(n => {
          if (!n.id_campanha) {
            msgDiretas.push(n)
          }
        })
        this.notificacoes = msgDiretas
        this.$refs.inbox.doLayout()
      } else {
        await this.init()
      }
    },
    estiloLinha (row, columnIndex) {
      const estilo = {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}1d`,
        'border': `0px solid ${this.estilo.aplicacao.corPrimariaAplicacao}2d`,
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }

      if (row.statusInbox === EnumStatusInbox.LIDO || row.statusInbox === EnumStatusInbox.CLICADO) {
        estilo.background = `#FFFFFF`
        estilo.border = `1px solid ${this.estilo.aplicacao.corPrimariaAplicacao}2d`
      }

      return estilo
    },
    layoutColumn (column) {
      if (column.field === 'id_funcionalidade') {
        return {
          xs: 2, sm: 2, md: 2, lg: 2, xl: 2
        }
      } else {
        return {
          xs: 22, sm: 22, md: 22, lg: 22, xl: 22
        }
      }
    },
    excluir () {
    },
    redirecFuncionalidade (row) {
      let data = {
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'REDIRECT',
        data: {
          idFuncionalidade: row.id_funcionalidade
        },
        timestamp: Date.now()
      }
      if (row.id_registro && row.id_registro !== '') data.data.idRegistro = row.id_registro
      window.parent.postMessage(data, '*')
    }
  }
}
</script>
